import {
  enableProdMode,
  isDevMode,
  provideCheckNoChangesConfig,
  provideZonelessChangeDetection,
} from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic()
  .bootstrapModule(AppModule, {
    applicationProviders: [
      // Zoneless (#44): views redraw when a signal they read changes, an event they bind fires,
      // an async pipe emits or markForCheck() is called — not after every timer or HTTP response.
      provideZonelessChangeDetection(),
      // Unoptimized (ng serve) builds only: re-check every view each second, OnPush ones included,
      // so a template value that changed without telling Angular shows up as an NG0100 error in
      // the console instead of as a screen that silently stays stale.
      ...(isDevMode() ? [provideCheckNoChangesConfig({ exhaustive: true, interval: 1000 })] : []),
    ],
  })
  .catch(err => console.error(err));
